<template>
  <button
    type="submit"
    class="button"
    :class="{ loading: loadStatus }"
    v-ripple="{ color: '#333542' }"
  >
    <slot></slot>
  </button>
</template>

<script>
export default {
  name: 'submit-button',
  props: {
    loadStatus: {
      type: Boolean,
      default: false
    },
  },
}
</script>

<style scoped lan="less">
.button {
  width: 100%;
  display: block;
  height: 44px;
  line-height: 44px;
  text-align: center;
  font-size: 15px;
  font-weight: 600;
  background-color: #e9b10e;
  color: #1a1c24;
  font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;
  outline: none;
  border: none;
  border-radius: 5px;
  position: relative;
  color: rgb(63, 63, 63);
}

.button.loading {
  background-color: #24252f;
}
</style>